/* Converted to vanilla JS */
function RichTextEditorStickyContent(rtegContainer) {
    var menu = rtegContainer.querySelector('.rich-text-editor-groups-menu');

    if (window.innerWidth > 768) {
        var rect = rtegContainer.getBoundingClientRect();
        var docTop = window.pageYOffset || document.documentElement.scrollTop;
        var upperLimit = (rtegContainer.getBoundingClientRect().top + docTop) - 110;
        var lowerLimit = (rtegContainer.getBoundingClientRect().top + docTop) + rtegContainer.offsetHeight - menu.offsetHeight - 110;
        var menuFinalPosition = rtegContainer.offsetHeight - menu.offsetHeight;
        var containerLeftPosition = rtegContainer.getBoundingClientRect().left + window.pageXOffset;
        var containerMenuWidth = (rtegContainer.offsetWidth * 0.3) + 'px';

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > upperLimit && scrollTop < lowerLimit) {
            menu.style.position = 'fixed';
            menu.style.top = '110px';
            menu.style.left = containerLeftPosition + 'px';
            menu.style.width = containerMenuWidth;
        } else if (scrollTop >= lowerLimit) {
            menu.style.position = '';
            menu.style.top = menuFinalPosition + 'px';
            menu.style.left = '0px';
            menu.style.width = '';
        } else if (scrollTop <= upperLimit) {
            menu.style.position = '';
            menu.style.top = '';
            menu.style.left = '0px';
            menu.style.width = '';
        } else {
            menu.style.position = '';
            menu.style.top = '';
            menu.style.left = '0px';
            menu.style.width = '';
        }

        // work out active menu item
        var anchors = Array.prototype.slice.call(menu.querySelectorAll('a')).reverse();
        anchors.forEach(function (a) {
            var scrollElementClass = a.getAttribute('data-scroll-element');
            if (!scrollElementClass) return;
            var scrollElement = document.querySelector('.' + scrollElementClass);
            if (!scrollElement) return;
            var elTop = scrollElement.getBoundingClientRect().top + window.pageYOffset - 110;
            var elBottom = scrollElement.getBoundingClientRect().top + window.pageYOffset + scrollElement.offsetHeight;
            if (scrollTop > elTop && scrollTop < elBottom) {
                a.classList.add('active');
            } else {
                a.classList.remove('active');
            }
        });
    } else {
        menu.style.position = 'static';
    }
}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        document.addEventListener('scroll', function () {
            document.querySelectorAll('.rich-text-editor-groups').forEach(function (el) {
                RichTextEditorStickyContent(el);
            });
        });
    }, 2000);
});


